// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__dashboard_container {
  width: 100%;
  height: 100%;
  padding: 20px;
}
.app__dashboard-title {
  font-size: 3rem; /* Große Schriftgröße */
  font-weight: bold; /* Fettgedruckter Text */
  color: var(--color-white); /* Weiße Schriftfarbe */
  text-transform: uppercase; /* Großbuchstaben */
  margin-bottom: 2rem; /* Abstand zum nächsten Element */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8); /* Ein leichter Textschatten für Tiefe */
  position: relative;
  text-align: center;
}

.logout-button {
  background-color: var(--color-dark-blue);
  max-width: 150px;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  font-size: 1.5rem; /* Größere Schriftart für den Button */
  font-family: "SawtonCircular-Medium";
  transition: background-color 0.3s ease;
  margin: 0 auto;
}
.logout-input:focus {
  border-color: #007bff; /* Farbänderung beim Fokussieren */
}

.logout-button:hover {
  background-color: #007bff; /* Dunkleres Blau beim Überfahren */
}
@media screen and (max-width: 450px) {
  .app__dashboard-title {
    font-size: 2.5rem;
    padding-top: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe,EAAE,uBAAuB;EACxC,iBAAiB,EAAE,wBAAwB;EAC3C,yBAAyB,EAAE,uBAAuB;EAClD,yBAAyB,EAAE,mBAAmB;EAC9C,mBAAmB,EAAE,iCAAiC;EACtD,2CAA2C,EAAE,wCAAwC;EACrF,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB,EAAE,sCAAsC;EACzD,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,qBAAqB,EAAE,kCAAkC;AAC3D;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;AACA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".app__dashboard_container {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 20px;\r\n}\r\n.app__dashboard-title {\r\n  font-size: 3rem; /* Große Schriftgröße */\r\n  font-weight: bold; /* Fettgedruckter Text */\r\n  color: var(--color-white); /* Weiße Schriftfarbe */\r\n  text-transform: uppercase; /* Großbuchstaben */\r\n  margin-bottom: 2rem; /* Abstand zum nächsten Element */\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8); /* Ein leichter Textschatten für Tiefe */\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.logout-button {\r\n  background-color: var(--color-dark-blue);\r\n  max-width: 150px;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin-top: 40px;\r\n  font-size: 1.5rem; /* Größere Schriftart für den Button */\r\n  font-family: \"SawtonCircular-Medium\";\r\n  transition: background-color 0.3s ease;\r\n  margin: 0 auto;\r\n}\r\n.logout-input:focus {\r\n  border-color: #007bff; /* Farbänderung beim Fokussieren */\r\n}\r\n\r\n.logout-button:hover {\r\n  background-color: #007bff; /* Dunkleres Blau beim Überfahren */\r\n}\r\n@media screen and (max-width: 450px) {\r\n  .app__dashboard-title {\r\n    font-size: 2.5rem;\r\n    padding-top: 3rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
